<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12">
              <v-select
                dense
                outlined
                :items="countries"
                item-text="name"
                item-value="id"
                :label="$t('fields.start_point_address_country_id')"
                v-model="form.start_point_address.country_id"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                :disabled="startPointStates.length === 0"
                :label="$t('fields.start_point_address_state_id')"
                dense
                outlined
                :items="startPointStates"
                item-text="name"
                item-value="id"
                v-model="form.start_point_address.state_id"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                :disabled="startPointCites.length === 0"
                :label="$t('fields.start_point_address_city_id')"
                dense
                outlined
                :items="startPointCites"
                item-text="name"
                item-value="id"
                v-model="form.start_point_address.city_id"
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-text-field
                dense
                :label="$t('fields.start_point_address_address_line_one')"
                outlined
                v-model="form.start_point_address.address_line_one"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                dense
                :label="$t('fields.start_point_address_address_line_two')"
                outlined
                v-model="form.start_point_address.address_line_two"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                maxLength="5"
                oninput="this.value= this.value&&this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/\+/g,'').replace(/\./g,'');"
                dense
                :label="$t('fields.start_point_address_address_postal_code')"
                outlined
                v-model="form.start_point_address.postal_code"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12">
              <v-select
                dense
                outlined
                :items="countries"
                :label="$t('fields.end_point_address_country_id')"
                item-text="name"
                item-value="id"
                v-model="form.end_point_address.country_id"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                :disabled="endPointState.length === 0"
                :label="$t('fields.end_point_address_state_id')"
                dense
                outlined
                :items="endPointState"
                item-text="name"
                item-value="id"
                v-model="form.end_point_address.state_id"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                :disabled="endPointCities.length === 0"
                :label="$t('fields.end_point_address_city_id')"
                dense
                outlined
                :items="endPointCities"
                item-text="name"
                item-value="id"
                v-model="form.end_point_address.city_id"
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-text-field
                dense
                :label="$t('fields.end_point_address_address_line_one')"
                outlined
                v-model="form.end_point_address.address_line_one"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                dense
                :label="$t('fields.end_point_address_address_line_two')"
                outlined
                v-model="form.end_point_address.address_line_two"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                maxLength="5"
                oninput="this.value= this.value&&this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/\+/g,'').replace(/\./g,'');"
                dense
                :label="$t('fields.end_point_address_address_postal_code')"
                outlined
                v-model="form.end_point_address.postal_code"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SecondStep",
  inject: ["$v"],
  props: {
    countries: {
      type: Array,
      default: () => []
    },
    endPointState: {
      type: Array,
      default: () => []
    },
    startPointStates: {
      type: Array,
      default: () => []
    },
    endPointCities: {
      type: Array,
      default: () => []
    },
    startPointCites: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
